// extracted by mini-css-extract-plugin
export default {"card":"ErrorCard_card__CsimP"};